import isEmpty from 'lodash.isempty'

export const validate = (value: string|number|boolean, label: string, validationList: Array<string> | undefined) => {
  if (!validationList) return ''
  const errors = validationList.map((validate: string) => {
    switch (validate) {
      case 'required':
        if (value === undefined || value === null || isEmpty(String(value))) return `${label}は必須項目です`
        return ''
      case 'requiredOther':
        if(typeof value !== "string") return ''
        if (value === "その他" && isEmpty(value && value.split("|")[1])) {
          return `${label}がその他の場合はテキスト必須項目です`
        }
        return ''
      default:
        return ''
    }
  })
  return errors.filter(e => !isEmpty(e)).join(' ')
}
